export default __webpack_public_path__ + "static/olive-tall-one-e18badb2e65b356885219adbaf572b69.jpg";